<template>
    <div>
        <navbar></navbar>
        <div class="container"> 
            <p class="__somep">Case studies of Software Projects</p>
            <p class="__absom">Some of our Software Projects</p>
            <p class="__abproduct1">Our clientele comprises some of the most progressive companies across the globe. We work with businesses spanning different sectors but having the same desire - the need for great tech. We listen to our clients and with distinctive collaboration, transform their big ideas into exceptional products.<br>We work with the best and deliver the best, such that when your product launches, you are guaranteed two things - smiles and satisfaction.</p>
            <p class="__abproduct1">Send us a mail at <a href="mailto:info@findworka.com" class="__sendmess"> info@findworka.com</a> to say hello and can also <router-link to="/build" class="__sendmess">begin a project</router-link> with us.</p>
        </div>    
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/eko" class="__procards">
                            <img src="../assets/img/ekolanding.png" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">Bringing Lagos Data to Life— How Findworka Built the EKO360 Interactive Dashboard for Data Science Nigeria</p>
								<!-- <p class="__dept">{{ project.tasks }}</p> -->
								<p class="__meetdname"><span class="__namp">Product Name:</span> EKO360 - Interactive Data Visualization Dashboard</p>
								<p class="__meetdname"><span class="__namp">Client Name:</span> Data Science Nigeria (DSN)</p>
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>

				<div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/tracka" class="__procards">
                            <img src="../assets/img/trackalanding.png" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">Building Tracka – Empowering Nigerian Citizens Through Tech</p>
								<!-- <p class="__dept">{{ project.tasks }}</p> -->
								<p class="__meetdname"><span class="__namp">Product Name:</span> Tracka – A Civic Engagement & Public Project Tracking Platform</p>
								<p class="__meetdname"><span class="__namp">Client Name:</span> BudgIT Nigeria</p>
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>

				<div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/anfana" class="__procards">
                            <img src="../assets/img/oldphone.jpg" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">Building Anfana – Everyday Shopping, Seamlessly Digital</p>
								<!-- <p class="__dept">{{ project.tasks }}</p> -->
								<p class="__meetdname"><span class="__namp">Product Name:</span> E-Commerce Platform for Fashion, Gadgets & Essentials</p>
								<p class="__meetdname"><span class="__namp">Client Name:</span> Anfana</p>
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>


				<div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="__procards">
                       <router-link to="/equalyz" class="__procards">
                            <img src="../assets/img/equalyz.png" class="__climgpro">
                            <div class="__divpro">
								<p class="__meetdname __namp">How Findworka Built equalyz.ai for Data Science Nigeria</p>
								<!-- <p class="__dept">{{ project.tasks }}</p> -->
								<p class="__meetdname"><span class="__namp">Product Name:</span> Equalyz.ai</p>
								<p class="__meetdname"><span class="__namp">Client Name:</span> Data Science Nigeria (DSN)</p>
								
								<!-- <p class="__soci">{{ project.shortDescription }}</p> -->
								<p class="__a">Learn More &nbsp;<span><i class="fas fa-arrow-right shake"></i></span></p>
							</div>
						</router-link>
					</div>
                </div>
            </div>
			
		</div>
        

        <div class="__stbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-5">
                        <p class="__wwd">Start Project</p>
                        <p class="__fbuild">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                        <router-link to="/build" class="btn __startp">Start Project</router-link>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar from "../components/navbar";

	export default {
        components: { navbar },
		data(){
			return {}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/css/project';
</style>


// WEBPACK FOOTER //
// src/components/Case-Studies-Software-Project.vue